import React from 'react';
import PropTypes from 'prop-types';

class TabsHeader extends React.Component {

  constructor(props) {
    super(props);
    this.headerRefs = props.items.map(() => React.createRef());
  }

  componentDidMount() {
    // forceUpdate needed to init refs after first render
    if (!this.headerRefs.current) this.forceUpdate();
  }

  static defaultProps = {
    onClick: () => {},
  };

  // static propTypes = {
  //   onClick: PropTypes.func,
  //   items: PropTypes.arrayOf(PropTypes.string).isRequired,
  // };

  prepareHeaderItems = () => {
    return this.props.items.map((item, index) => (
      <button
        className={this.props.selectedTabId === index ? 'tab is-active' : 'tab'}
        type="button"
        style={item.style}
        key={`headerTab_${index}`}
        ref={this.headerRefs[index]}
        onClick={() => {
          this.props.onClick(index);
          this.props.onItemClick[index]();
        }}
      >
        {item.component}
      </button>
    ));
  };

  render() {
    const itemsStr = this.prepareHeaderItems();
    return (
      <div className="tabs__head">
        <div className="tabs__container container">
          <div className="tabs__wrap">
            {itemsStr}
            <span
              style={{
                width: this.headerRefs[this.props.selectedTabId]?.current
                  ?.offsetWidth,
                left: this.headerRefs[this.props.selectedTabId]?.current
                  ?.offsetLeft,
              }}
            ></span>
          </div>
        </div>
      </div>
    );
  }
}

export default TabsHeader;
